import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from "./redux";
import CSSModules from "react-css-modules";
import ReactHighcharts  from 'react-highcharts'
import { number } from "../../../utils";
import moment from 'moment';

import styles from "./styles.scss";

const dateFormat = "dddd, MMM Do, h:mm A";
const altDateFormat = "h:mm A";

@CSSModules(styles, { allowMultiple: true })
class CostPerHourChart extends Component {
    constructor(props){
        super(props);
        this.chart = React.createRef();
    }
    
	render() {
        const config = {
            credits: {
                enabled: false,
            },
            plotOptions: {
                series: {
                    pointPadding: 0,
                    groupPadding: 0,
                    grouping: false,
                },
                column: {
                    grouping: false,
                },
                line: {
                    dataGrouping: {
                        enabled: false,
                        groupAll: true,
                    },
                    turboThreshold: 0,
                },
            },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    hour: '%l%P',
                    day: '%e %b',
                },
                labels: {
                    step: 1,
                    y: 30,
                    style: {
                        fontSize: "14px",
                        color: '#999',
                    }
                },
                tickWidth: 0,
            },
            yAxis: {
                title: {
                    text: "$",
                    align: "high",
                    rotation: 0,
                    margin: 0,
                    y: -30,
                    offset: 14,
                    style: {
                        "font-weight": "600",
                        "font-size": "15px",
                        "font-family": "seravek-medium",
                    },
                },
                minRange: 20,
                min: 0,
                labels: {
                    formatter: function () {
                        return number.parseNumber(this.value);
                    },
                    style: {
                        fontSize: "14px",
                        color: '#999',
                    }
                },
                tickHeight: 0,
            },
            tooltip: {
                followTouchMove: false,
                formatter: function () {
                    return '<span style="font-size:10px">'
                        + moment(this.x).utc().format(dateFormat) + ' - ' + moment(this.x).utc().add(1, 'hour').format(altDateFormat) + 
                        '</span><br/>'
                        + '<br/><span style="color:'
                        + this.series.color
                        + ';">\u25CF\xa0</span>'
                        + '<b>$' + number.parseNumber(this.y, 2) + '</b>';
                },
            },
            chart:{
                type: 'column',
                animation: false,
                style: {
                    fontFamily: "Helvetica",
                }
            },
            title: {
              text: "Cost Per Hour",
              align: "left",
              margin: 60,
              style: {
                  "color": "#4D4D4D",
                  "font-size": "20px",
                  "font-weight": "600"
              },
            },
            legend: {
                enabled: false,
            },
            series: [
                {
                    type: 'column',
                    data: [],
                    pointIntervalUnit: 'hour',
                    zIndex: 2,
                    stack: 0,
                    pointPlacement: 'between',
                    color: '#2D9BB1',
                    name: 'Cost',
                    borderWidth: 1,
                    pointPadding: 0,
                    groupPadding: 0,
                    borderColor: 'white',
                }
            ],
          };
		return (
            <ReactHighcharts
			config={config}
			ref={this.chart}
			isPureConfig={false}
		  />
		);
    }

	componentDidMount(){
        let chart = this.chart.current.getChart();
		this.props.startComponent(chart);
	}

	componentWillUnmount(){
		this.props.stopComponent();
	}

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.currentSite !== this.props.currentSite || nextProps.currentTariff !== this.props.currentTariff){
            let chart = this.chart.current.getChart();
            this.props.startComponent(chart);
            return false;
        }else{
            return true;
        }
    }

}

const bindAction = dispatch => {
    return {
        startComponent: (chart) => dispatch(actions.startComponent(chart)),
        stopComponent: () => dispatch(actions.stopComponent()),
    };
};

const mapStateToProps = (state, ownProps) => ({
    currentSite: state.sitetree.currentSite,
    currentTariff: state.tariffs.currentTariff,
});

export default connect(mapStateToProps, bindAction)(CostPerHourChart);



// WEBPACK FOOTER //
// ./src/components/LiveComponents/CostPerHourChart/CostPerHourChart.js